import { SCENE_EVENTS } from "../MVC/Model";
import VideoJs from 'video.js';

export default class WelcomeScreen {
  constructor(model) {
    this.model = model;
    this.data = model.sceneData?.welcomeScreen;
    this.roomID = model.worldID;
    this.showScreenShare = false;
    this.media = null;
    this.withoutDesc = false;
    this.welcomeVideoPlayer = null;
    this._welcomeScreenWasActive = false;
    this._welcomeScreenObserver = null;

    this.data && this.toggleWelcomeScreenAvailability(this.data.show);
    this.ensureObserver();

    model.addEventListener(SCENE_EVENTS.TINY_WORLD_ANIMATION_ENDED, () => {
      this.openWelcome({ force: false });
    });
  }

  isOnStartRoom = () => {
    if (typeof this.model?.isStartRoom === 'function') {
      return this.model.isStartRoom();
    }
    const start = this.model?.sceneData?.scenes?.[0];
    const current = this.model?.currentScene;
    return !!(start && current && String(start.id) === String(current.id));
  }

  ensureObserver = () => {
    if (this._welcomeScreenObserver) return;
    try {
      const modalEl = document.getElementById('welcomeScreen');
      if (!modalEl || typeof MutationObserver === 'undefined') return;
      this._welcomeScreenWasActive = modalEl.classList.contains('is-active');
      this._welcomeScreenObserver = new MutationObserver(() => {
        const isActive = modalEl.classList.contains('is-active');
        if (this._welcomeScreenWasActive && !isActive) {
          this.cleanupWelcomeVideo({ keepObserver: true });
          this._fireWelcomeClosed();
        }
        // Re-read after actions that may reopen the modal in the same turn.
        this._welcomeScreenWasActive = modalEl.classList.contains('is-active');
      });
      this._welcomeScreenObserver.observe(modalEl, { attributes: true, attributeFilter: ['class'] });
    } catch (e) { /* no-op */ }
  }

  applyPortraitClasses = () => {
    let isPortrait = false;
    if (this.media === 'img') {
      const el = $("#welcome-image")[0];
      if (el) {
        isPortrait = el.naturalWidth < el.naturalHeight;
      }
    }
    if (this.media === 'video') {
      const el = document.querySelector("#welcomeScreenVideo");
      if (el) {
        isPortrait = el.videoWidth < el.videoHeight;
      }
    }
    $("#welcomeScreen > .modal-content").toggleClass("portrait", isPortrait);
    $("#welcomeScreen > .modal-content").toggleClass("only-media", isPortrait && this.withoutDesc);
    $("#welcomeScreen > .modal-content > #welcome-media").toggleClass("image", isPortrait && this.withoutDesc && this.media === 'img');
  }

  toggleWelcomeScreenAvailability = (state) => {
    if (!state) return;
    if (localStorage.getItem(`welcome_screen_${this.roomID}`)) {
      const show = JSON.parse(localStorage.getItem(`welcome_screen_${this.roomID}`));
      $("#showWelcomeScreen").prop("checked", show.state);
      this.showScreenShare = !!show.state;
    } else {
      this.showScreenShare = true;
      $("#showWelcomeScreen").prop("checked", true);
    }
    $("#welcome-screen-option").removeClass("disabled");
  }

  openWelcome = ({ force = false } = {}) => {
    const modal = document.getElementById('welcomeScreen');
    if (!modal) return;
    if (modal.classList.contains('is-active')) return;

    this.data = this.model?.sceneData?.welcomeScreen || this.data;
    if (!force && !this.showScreenShare) return;
    if (!force && !this.isOnStartRoom()) return;

    this.prepareAndShowWelcomeScreen();
    this.ensureObserver();
    modal.classList.add('is-active');
    this.applyPortraitClasses();
  }

  closeWelcome = () => {
    const modal = document.getElementById('welcomeScreen');
    if (!modal || !modal.classList.contains('is-active')) return;
    modal.classList.remove('is-active');
  }

  _fireWelcomeClosed = () => {
    if (this.model?.editMode) return;
    this.model?.view?._executeSceneEventActions?.('welcomeClosed');
  }

  prepareAndShowWelcomeScreen = () => {
    this.data = this.data || {};
    let img = '', video = '', desc1 = '';
    if (this.data.hasOwnProperty('imagePath')) {
      this.data.imagePath && (img = `<div id="welcome_screen_image_holder"><img src='${this.data.imagePath}' id="welcome-image" /></div`);
    }
    if (this.data.hasOwnProperty('videoPath')) {
      if (this.data.videoPath) {
        const posterAttr = this.data.imagePath ? ` poster='${this.data.imagePath}'` : '';
        //video = `<div id="welcome_screen_video_holder" class="active"><video id="welcomeScreenVideo" class="video-js vjs-big-play-centered"${posterAttr} autoplay muted playsinline webkit-playsinline controls><source src='${this.data.videoPath}'></source></video><div id="unmute_welcome_screen_video"><div style="position:absolute;top:40px;left:50%;transform:translateX(-50%);display:flex; background:rgba(0,0,0,0.35);padding:10px;"><span class='material-icons'>volume_off</span><div class="unmute-text">Unmute</div></div></div></div>`;
        video = `<div id="welcome_screen_video_holder" class="active" style="display:flex;align-items:center;justify-content:center;width:100%;"><video id="welcomeScreenVideo" class="video-js vjs-big-play-centered"${posterAttr} autoplay muted playsinline webkit-playsinline controls style="width:100%;height:auto;max-height:60vh;object-fit:contain;display:block;aspect-ratio:16/9;"><source src='${this.data.videoPath}'></source></video><div id="unmute_welcome_screen_video"><div style="position:absolute;top:40px;left:50%;transform:translateX(-50%);display:flex; background:rgba(0,0,0,0.35);padding:10px;"><span class='material-icons'>volume_off</span><div class="unmute-text">Unmute</div></div></div></div>`;
        // If there's a video, show its poster instead of a separate image element
        img = '';
      }
    }
    if (this.data.hasOwnProperty('description1')) {
      this.data.description1 && (desc1 = `<div>${JSON.parse(JSON.stringify(this.data.description1))}</div>`);
    }
    if (img) {
      this.media = 'img';
    }
    if (video) {
      this.media = 'video';
    }
    $("#welcome-media").html(`${video}${img}`);
    $("#welcome-description").html(`${desc1}`);

    this.showScreenShare = true;
    this.withoutDesc = desc1 == '';

    // Initialize welcome screen video behavior if present
    if (this.media === 'video') {
      const videoElement = document.getElementById('welcomeScreenVideo');
      if (videoElement) {
        // Ensure inline muted autoplay on mobile
        videoElement.setAttribute('playsinline', '');
        videoElement.setAttribute('webkit-playsinline', '');
        videoElement.muted = true;
        videoElement.autoplay = true;
        const tryPlay = () => {
          const p = videoElement.play();
          if (p && typeof p.then === 'function') {
            p.catch(() => { });
          }
        };
        if (videoElement.readyState >= 2) {
          tryPlay();
        } else {
          videoElement.addEventListener('canplay', tryPlay, { once: true });
        }

        // Initialize Video.js for API control while keeping native controls/CSS
        try {
          if (this.welcomeVideoPlayer && typeof this.welcomeVideoPlayer.dispose === 'function') {
            this.welcomeVideoPlayer.dispose();
          }
        } catch (e) { /* no-op */ }
        this.welcomeVideoPlayer = VideoJs(videoElement, {
          controls: true,
          autoplay: false,
          preload: 'auto',
          fluid: false,
          responsive: false,
          playsinline: true,
          controlBar: {
            playToggle: true,
            volumePanel: true,
            currentTimeDisplay: true,
            timeDivider: true,
            durationDisplay: true,
            progressControl: true,
            remainingTimeDisplay: false,
            pictureInPictureToggle: false,
            fullscreenToggle: true
          }
        });

        const overlay = document.getElementById('unmute_welcome_screen_video');
        if (overlay) {
          // Ensure overlay visible until unmuted
          overlay.style.display = 'block';
          overlay.addEventListener('click', () => {
            if (this.welcomeVideoPlayer) {
              this.welcomeVideoPlayer.currentTime(0);
              this.welcomeVideoPlayer.muted(false);
              this.welcomeVideoPlayer.play();
            } else {
              try { videoElement.currentTime = 0; } catch (e) { }
              videoElement.muted = false;
              videoElement.play();
            }
            overlay.style.display = 'none';
          });
          const maybeHideOverlay = () => {
            const isMuted = this.welcomeVideoPlayer ? this.welcomeVideoPlayer.muted() : videoElement.muted;
            const volume = this.welcomeVideoPlayer ? this.welcomeVideoPlayer.volume() : videoElement.volume;
            if (!isMuted && volume > 0) {
              overlay.style.display = 'none';
            }
          };
          videoElement.addEventListener('volumechange', maybeHideOverlay);
          videoElement.addEventListener('play', maybeHideOverlay);
          if (this.welcomeVideoPlayer) {
            this.welcomeVideoPlayer.on('volumechange', maybeHideOverlay);
            this.welcomeVideoPlayer.on('play', maybeHideOverlay);
            this.welcomeVideoPlayer.ready(() => {
              const isMuted = this.welcomeVideoPlayer.muted();
              const volume = this.welcomeVideoPlayer.volume();
              overlay.style.display = (!isMuted && volume > 0) ? 'none' : 'block';
            });
          }
          // Initial state
          if (!videoElement.muted && videoElement.volume > 0) {
            overlay.style.display = 'none';
          } else {
            overlay.style.display = 'block';
          }
        }
      }
    }

  }

  cleanupWelcomeVideo = ({ keepObserver = false } = {}) => {
    try {
      // Dispose Video.js player if exists
      if (this.welcomeVideoPlayer && typeof this.welcomeVideoPlayer.dispose === 'function') {
        try { this.welcomeVideoPlayer.pause && this.welcomeVideoPlayer.pause(); } catch (e) { /* no-op */ }
        this.welcomeVideoPlayer.dispose();
      }
    } catch (e) { /* no-op */ }
    this.welcomeVideoPlayer = null;

    try {
      const videoElement = document.getElementById('welcomeScreenVideo');
      if (videoElement) {
        try { videoElement.pause(); } catch (e) { /* no-op */ }
        // Clear sources to release memory
        try {
          videoElement.removeAttribute('src');
          while (videoElement.firstChild) {
            videoElement.removeChild(videoElement.firstChild);
          }
          videoElement.load && videoElement.load();
        } catch (e) { /* no-op */ }
      }
    } catch (e) { /* no-op */ }

    // Remove the entire media content to fully detach listeners/DOM
    try {
      const mediaContainer = document.getElementById('welcome-media');
      if (mediaContainer) {
        mediaContainer.innerHTML = '';
      }
    } catch (e) { /* no-op */ }

    // Reset flags for next open
    this.media = null;
    this.withoutDesc = false;

    if (keepObserver) return;

    try {
      if (this._welcomeScreenObserver && typeof this._welcomeScreenObserver.disconnect === 'function') {
        this._welcomeScreenObserver.disconnect();
      }
    } catch (e) { /* no-op */ }
    this._welcomeScreenObserver = null;
    this._welcomeScreenWasActive = false;
  }

  // Full teardown in case this component is being destroyed
  destroy = () => {
    this.cleanupWelcomeVideo();
    try {
      if (this._welcomeScreenObserver && typeof this._welcomeScreenObserver.disconnect === 'function') {
        this._welcomeScreenObserver.disconnect();
      }
    } catch (e) { /* no-op */ }
    this._welcomeScreenObserver = null;
    this._welcomeScreenWasActive = false;
  }
}